export enum verificationTypes {
  login = 'login', 
  signup = 'signup',
  phoneVerifyOrUpdate = 'phone_verify_or_update',
  forcePhoneVerification = 'force_phone_verification',
  userInvite = 'user_invite',
}